<template>
  <div class="content-block image-text-link-slide">
    <NuxtLink :to="item.linkDefault ? localePath(item.linkDefault) : '#'">
      <div class="content-block__swiper__slide">
        <div
          v-if="item.portrait.length"
          class="content-block__swiper__slide__image"
        >
          <WidgetPicture
            :image="{ custom: item.portrait?.[0] }"
            :alt="item.portrait?.[0]?.title"
          />
        </div>
        <div class="content-block__swiper__slide__text">
          <div>
            <div
              v-if="item?.sectionTitle"
              class="content-block__swiper__slide__title title-base5"
            >
              <div v-html="item.sectionTitle" />
            </div>
            <div
              v-if="item?.text"
              class="content-block__swiper__slide__description text-base"
            >
              <div v-html="item.text" />
            </div>
          </div>
          <div
            v-if="item?.linkDefault"
            class="content-block__swiper__slide__link"
          >
            <div class="text-medium5 default-icon-btn is-medium-bold">
              <span v-html="item.label" />
              <ArrowIcon alt="Arrow icon" class="icon-arrow" />
            </div>
          </div>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<script>
export default {
  name: 'ImageTextLinkSlide',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
